<template>
    <v-card>
        <v-card-title class="justify-center">
            <h2>Editar Convênio</h2>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="editForm" lazy-validation>
            <v-text-field
                v-if="desconto !== null"
                outline
                label="Desconto"
                v-model="desconto"
                :disabled="desconto_em_reais !== null"
                suffix="%"
                type="number" :rules="[
                  v => v !== null && v !== '' || 'Informe um valor',
                  v => parseFloat(v) >= 0 || 'Desconto inválido',
                  v => parseFloat(v) <= 100 || 'Desconto inválido'
                ]"
            >
            </v-text-field>
            <v-text-field
                v-else
                outline
                label="Desconto em Reais"
                v-model="desconto_em_reais"
                :disabled="desconto !== null"
                suffix="R$"
                v-money="money"
                :rules="[
                  v => v !== null && v !== '' || 'Informe um valor',
                  v => formatarValor(v) > -1 || 'Desconto minimo de 0,00',
                  v => formatarValor(v) <= 4 || 'Desconto máximo de R$4,00'
                ]"
            >
            </v-text-field>
            <v-select
              outline
              label="Item"
              v-model="item"
              :items="[{ nome: 'Todos os Itens', id: 0 }, ...todos_itens]"
              item-text="nome"
              item-value="id"
              hide-details
              single-line
            >
            </v-select>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn
                round
                class="mb-3"
                @click="$emit('fechar')"
            >Fechar</v-btn>
            <v-btn
                round
                class="mb-3"
                @click="atualizarConvenio"
                color="success"
            >Editar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { VMoney } from 'v-money'
export default {
  directives: { money: VMoney },
  props: ['convenio_posto'],
  data: () => ({
    valid: false,
    desconto: 0,
    id_combustivel: 0,
    todos_itens: [],
    item: null,
    desconto_em_reais: 0,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    }
  }),
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    this.pegarTodosItens()
    if (this.convenio_posto) {
      this.desconto = this.convenio_posto.percentual_desconto
      this.desconto_em_reais = this.convenio_posto.desconto_em_reais
      if (this.convenio_posto.combustivel) {
        this.id_combustivel = this.convenio_posto.combustivel.id_combustivel
      }
      if (this.convenio_posto.item) {
        this.item = this.convenio_posto.item.id
      }
    }
  },
  methods: {
    formatarValor (valor) {
      return parseFloat(valor.replace('R$ ', '').replace('.', '').replace(',', '.'))
    },
    atualizarConvenio () {
      if (this.$refs.editForm.validate()) {
        const payload = {
          id: this.convenio_posto.id,
          data: {
            ...this.convenio_posto,
            combustivel: this.id_combustivel === 0 ? null : this.id_combustivel,
            percentual_desconto: this.desconto_em_reais === null ? this.desconto : null,
            desconto_em_reais: this.desconto === null
              ? parseFloat(this.desconto_em_reais.replace('R$ ', '').replace('.', '').replace(',', '.'))
              : null,
            item: this.item === 0 ? null : this.item
          }
        }
        this.$store.dispatch('atualizarConvenio', payload).then(() => {
          this.$emit('carregar')
          this.$emit('fechar')
        })
      }
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj
        }
      }
      data.parameters.categoria__referencia__icontains = 'combustivel'
      this.$store.dispatch('itens', data).then(json => {
        this.todos_itens = json
      })
    }
  }
}
</script>
